// src/components/portfolio/IconSelector.js
import React, { useState } from 'react';

const IconSelector = ({ onSelect, currentIcon }) => {
  const [isOpen, setIsOpen] = useState(false);

  // Market flags and icons
  const MARKET_FLAGS = [
    '🇺🇸', // NYSE, NASDAQ (USA)
    '🇬🇧', // LSE (UK)
    '🇯🇵', // JPX (Japan)
    '🇨🇳', // SSE (China)
    '🇭🇰', // HKEX (Hong Kong)
    '🇩🇪', // FWB (Germany)
    '🇫🇷', // Euronext Paris
    '🇨🇭', // SIX (Switzerland)
    '🇹🇷', // Borsa Istanbul
    '🇰🇷', // KRX (South Korea)
    '🇮🇳', // BSE (India)
    '🇨🇦', // TSX (Canada)
    '🇦🇺', // ASX (Australia)
    '🇧🇷', // B3 (Brazil)
    '🇸🇬', // SGX (Singapore)
  ];

  // Portfolio icons
  const PORTFOLIO_ICONS = [
    '💼', '📊', '📈', '💰', '🏦', '💵', '📑',
    '📁', '📂', '🗂️', '📋', '📌', '🎯', '⭐',
    '💎', '🏆', '🌟', '📱', '💻', '🖥️', '🏢',
    '🏛️', '🏪', '🏭', '🏗️', '🌐', '🔑', '⚡'
  ];

  const handleIconSelect = (icon, event) => {
    event.preventDefault();
    event.stopPropagation();
    onSelect(icon);
    setIsOpen(false);
  };

  return (
    <div className="relative">
      <button
        type="button" // Prevent form submit
        onClick={(e) => {
          e.preventDefault(); // Prevent form submit
          e.stopPropagation(); // Stop event bubbling
          setIsOpen(!isOpen);
        }}
        className="p-2 rounded-md bg-gray-100 dark:bg-[#1f2544] border border-gray-200 dark:border-gray-700 text-xl hover:bg-gray-200 dark:hover:bg-[#2a305e] transition-colors"
        title="Portföy ikonu seç"
      >
        {currentIcon || '💼'}
      </button>

      {isOpen && (
        <>
          <div 
            className="fixed inset-0 bg-black bg-opacity-50 z-[9998]" 
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              setIsOpen(false);
            }} 
          />
          <div 
            className="absolute p-4 bg-white dark:bg-[#151934] rounded-lg shadow-xl border border-gray-200 dark:border-gray-700 w-[280px] z-[9999]"
            style={{
              left: '50%',
              transform: 'translateX(-50%)',
              marginTop: '0.5rem'
            }}
          >
            <div className="mb-4">
              <h3 className="text-sm font-medium mb-2 text-gray-700 dark:text-gray-300">Borsa Bayrakları</h3>
              <div className="grid grid-cols-5 gap-2">
                {MARKET_FLAGS.map((flag, index) => (
                  <button
                    key={`flag-${index}`}
                    onClick={(e) => handleIconSelect(flag, e)}
                    className="p-2 text-xl rounded hover:bg-gray-100 dark:hover:bg-[#1f2544]"
                  >
                    {flag}
                  </button>
                ))}
              </div>
            </div>

            <div>
              <h3 className="text-sm font-medium mb-2 text-gray-700 dark:text-gray-300">Portföy İkonları</h3>
              <div className="grid grid-cols-5 gap-2">
                {PORTFOLIO_ICONS.map((icon, index) => (
                  <button
                    key={`icon-${index}`}
                    onClick={(e) => handleIconSelect(icon, e)}
                    className="p-2 text-xl rounded hover:bg-gray-100 dark:hover:bg-[#1f2544]"
                  >
                    {icon}
                  </button>
                ))}
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default IconSelector;